import React from 'react';
import { Microscope, Clipboard, Award, GraduationCap, ArrowRight } from 'lucide-react';
export function Activities() {
  const activities = [{
    title: 'Conduct Original Research',
    description: 'Basic science, applied studies, and clinical trials',
    icon: <Microscope size={24} data-id="element-60" data-mp="xwuvdhuv4sfe" />,
    link: '/research-hub'
  }, {
    title: 'Develop and Validate Protocols',
    description: 'Like the Microbiota Reset Program',
    icon: <Clipboard size={24} data-id="element-61" data-mp="bp3shz4xwne" />,
    link: '/microbiota-reset-program'
  }, {
    title: 'Benchmark Supplements',
    description: 'With Ukweli Certified™ three-tier validation',
    icon: <Award size={24} data-id="element-62" data-mp="a9wgupqazuk4" />,
    link: '/certification'
  }, {
    title: 'Deliver Equitable Health Solutions',
    description: 'Worldwide through the Afya Program',
    icon: <GraduationCap size={24} data-id="element-63" data-mp="1lmffw56nzxqs" />,
    link: '/about/afya-program'
  }];
  return <section className="py-16 bg-white" data-id="element-64" data-mp="1pmpkpeiq0i42">
      <div className="container mx-auto px-4" data-id="element-65" data-mp="1zurgvxs8jpml">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-66" data-mp="1ztgd3xysihvh">
          <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-67" data-mp="1uv6etehrr15n">What We Do</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-68" data-mp="1pwlcn9iyi7ek"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-69" data-mp="1pyodyppk7myl">
          {activities.map((activity, index) => <div key={index} className="bg-navy-50 p-6 rounded-lg hover:shadow-md transition-all duration-300 group" data-id="element-70" data-mp="1lx2s4ev1ryc9" data-mpi={index}>
              <div className="flex items-start" data-id="element-71" data-mp="1c45eon4wwzki">
                <div className="bg-white p-3 rounded-full shadow-sm mr-4" data-id="element-72" data-mp="1c3dnrpm9fq0k">
                  <div className="text-teal-600" data-id="element-73" data-mp="176ddt3mai346">{activity.icon}</div>
                </div>
                <div data-id="element-74" data-mp="128lkq69wsaye">
                  <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-75" data-mp="12565n3g8j1wz">
                    {activity.title}
                  </h3>
                  <p className="text-navy-700 mb-4" data-id="element-76" data-mp="t5swyczxqhdb">{activity.description}</p>
                  <a href={activity.link} className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors duration-200" data-id="element-77" data-mp="jiqc8p15tshu">
                    Learn more
                    <ArrowRight size={16} className="ml-1 transform group-hover:translate-x-1 transition-transform duration-200" data-id="element-78" data-mp="9lkkrfomvzh3" />
                  </a>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-79" data-mp="1779iz04k9x7t">
          <h3 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-80" data-mp="17adsmd0spl5v">
            Why CalMiR is Different
          </h3>
          <div className="flex flex-wrap justify-center gap-4 mt-6" data-id="element-81" data-mp="xihwh7i9s54a">
            <div className="bg-navy-50 px-6 py-3 rounded-full text-navy-700" data-id="element-82" data-mp="xgnb5s336azo">
              Academic Rigor
            </div>
            <div className="bg-navy-50 px-6 py-3 rounded-full text-navy-700" data-id="element-83" data-mp="1pyskt3mun589">
              Trust & Transparency
            </div>
            <div className="bg-navy-50 px-6 py-3 rounded-full text-navy-700" data-id="element-84" data-mp="3aoeho3xcgrqq">
              Global Mission
            </div>
            <div className="bg-navy-50 px-6 py-3 rounded-full text-navy-700" data-id="element-85" data-mp="35pbjn3fs7ls9">
              Innovation Pipeline
            </div>
          </div>
        </div>
      </div>
    </section>;
}